module.exports = __webpack_public_path__ + "media/loadingCoffe.24b2d86a.mp4";